// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-searchbar {
  margin: 0px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/location-picker/location-picker.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,mBAAA;AACJ","sourcesContent":["ion-searchbar{\n    margin: 0px;\n    margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
